import styled from "styled-components";
import {ListTitleIconDefaultBox} from "./list-title-icon.default.box";
import {JACKPOT_WIDGET} from '../../constants';

export const ListTitleIconWsopCipBox = styled(ListTitleIconDefaultBox)`
    .${JACKPOT_WIDGET} & {
        background-image: url("${props => props.theme.images.miniOrbit.gamesListTitleOverride.dailyJackpot.toString()}");
    }
`;